import classNames from 'classnames'
import SvgAlert from 'icons/Alert'
import React, { HTMLAttributes } from 'react'

export interface ActionDialogWarning extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export default function ActionDialogWarning(props: ActionDialogWarning) {
  const { children, className } = props
  const mergedClassName = classNames('admin-action-dialog__warning', className)

  return (
    <div className={mergedClassName}>
      <SvgAlert />
      {children}
    </div>
  )
}
